<template>
  <div class="analysis-page row-block" :style="{ minHeight: minHeight }">
    <div class="filter-container" :style="{ width: '250px' }">
      <analysisFilter
        :minHeight="minHeight"
        :disabled="tabState === 'graph'"
        :title="{
          competitiveness: '市場競爭力分析',
          attraction: '市場吸引力分析',
          toolcompetitiveness: '農業機械市場競爭力分析',
          toolattraction: '農業機械市場吸引力分析'
        }[analysisType]"
        :filters="{
          init: init.filters,
          options: filterOptions
        }"
        @changeFilters="c => { conditions.filters = c; searchDatas(true) }"
        :weightings="{
          init: init.weightings,
          options: weightingOptions,
          disabled: !this.datas.length
        }"
        @changeWeightings="c => conditions.weightings = c"
      ></analysisFilter>
    </div>
    <div class="panel-container" :style="{ flex: 1 }">
      <div v-if="onSearch" class="mask center-block">
        <!-- <img :src="require('../../assets/images/loading.gif')"> -->
        <img :src="require('../../assets/images/upload.svg')" alt="">
      </div>
      <analysisPanel
        :dataType="'country'"
        :minHeight="minHeight"
        :datas="datas"
        :reportCountrys="reportCountrys || []"
        :filterOptions="{
          filters: filterOptions,
          weightings: weightingOptions
        }"
        :conditions="conditions"
        @changeState="s => tabState = s"
      ></analysisPanel>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { getProducts, getYears, getCompetitivenessDatas, getAttractionDatas, getReportCountrys } from '../../api'
import analysisFilter from '../../components/analysis/filter'
import analysisPanel from '../../components/analysis/panel'
import routeLoading from '../../mixins/routeLoading'
import toastMethods from '../../mixins/toastMethods'

export default {
  components: {
    analysisFilter,
    analysisPanel
  },
  mixins: [
    routeLoading,
    toastMethods
  ],
  props: {
    minHeight: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      datas: [],
      reportCountrys: [],
      options: {
        products: [],
        years: []
      },
      init: {
        filters: {},
        weightings: {}
      },
      conditions: {
        filters: {},
        weightings: {}
      },
      onSearch: false,
      tabState: 'table'
    }
  },
  computed: {
    ...mapGetters([
      'countrys'
    ]),
    analysisType () {
      return this.$route.name
    },
    countryOptions () {
      return this.countrys.map(([key, value]) => ({
        title: value.chinese_name + '(' + value.iso_name + ')',
        value: key,
        country: value
      }))
    },
    // static
    filterOptions () {
      return {
        competitiveness: [
          {
            title: '產品項目',
            value: 'product',
            type: 'select',
            options: this.options.products,
            placeholder: () => '水果、蔬菜...'
          },
          {
            title: '目標市場',
            value: 'country',
            type: 'datalist',
            lists: value => this.countryOptions.map(option => option.title),
            options: this.countryOptions,
            placeholder: () => '國家名稱...',
            onChange: value => {
              if (value && !this.countryOptions.some(option => option.title === value)) {
                this.init.filters = {
                  ...this.init.filters,
                  ...this.conditions.filters,
                  country: ''
                }
              }
            },
            outputFormat: value => (this.countryOptions.find(option => option.title === value) || {}).value
          },
          {
            title: '年份',
            value: 'year',
            type: 'select',
            options: this.options.years,
            placeholder: () => '年份'
          }
        ],
        attraction: [
          {
            title: '產品項目',
            value: 'product',
            type: 'select',
            options: this.options.products,
            placeholder: () => '水果、蔬菜...'
          },
          {
            title: '年份',
            value: 'year',
            type: 'select',
            options: this.options.years,
            placeholder: () => '年份'
          }
        ],
        toolcompetitiveness: [
          {
            title: '產品項目',
            value: 'product',
            type: 'select',
            options: this.options.products,
            placeholder: () => '農業機械...'
          },
          {
            title: '目標市場',
            value: 'country',
            type: 'datalist',
            lists: value => this.countryOptions.map(option => option.title),
            options: this.countryOptions,
            placeholder: () => '國家名稱...',
            onChange: value => {
              if (value && !this.countryOptions.some(option => option.title === value)) {
                this.init.filters = {
                  ...this.init.filters,
                  ...this.conditions.filters,
                  country: ''
                }
              }
            },
            outputFormat: value => (this.countryOptions.find(option => option.title === value) || {}).value
          },
          {
            title: '年份',
            value: 'year',
            type: 'select',
            options: this.options.years,
            placeholder: () => '年份'
          }
        ],
        toolattraction: [
          {
            title: '產品項目',
            value: 'product',
            type: 'select',
            options: this.options.products,
            placeholder: () => '農業機械...'
          },
          {
            title: '年份',
            value: 'year',
            type: 'select',
            options: this.options.years,
            placeholder: () => '年份'
          }
        ]
      }[this.analysisType]
    },
    weightingOptions () {
      return {
        competitiveness: [
          {
            title: '產量',
            value: 'production_quantity'
          },
          {
            title: '單位面積產量',
            value: 'yield'
          },
          {
            title: '生產者價格',
            value: 'producer_price'
          },
          {
            title: '進口單價',
            value: 'import_price'
          },
          {
            title: 'RCA',
            value: 'RCA'
          },
          {
            title: 'TII',
            value: 'TII'
          },
          {
            title: '市場距離',
            value: 'distance'
          }
        ],
        attraction: [
          {
            title: '產量',
            value: 'production_quantity'
          },
          {
            title: '出口值',
            value: 'export_value'
          },
          {
            title: '進口值',
            value: 'import_value'
          },
          {
            title: '市場規模',
            value: 'market_size'
          },
          {
            title: '進口市場成長趨勢',
            value: 'import_market_growth_trend'
          },
          {
            title: 'TSI',
            value: 'TSI'
          },
          {
            title: '市場距離',
            value: 'distance'
          },
          {
            title: '佔全球貿易市場佔有率',
            value: 'market_share'
          },
          {
            title: '平均每人GDP',
            value: 'GDP'
          },
          {
            title: '人口數',
            value: 'total_population'
          },
          {
            title: '市場成長相對強度',
            value: 'market_growth_intensity'
          },
          {
            title: '進口市場表現',
            value: 'market_performance'
          },
          {
            title: '市場開放程度',
            value: 'market_openness'
          },
          {
            title: '市場相對優惠關稅',
            value: 'market_preferential_tariff'
          }
        ],
        toolcompetitiveness: [
          {
            title: '進口單價',
            value: 'import_price'
          },
          {
            title: 'RCA',
            value: 'RCA'
          },
          {
            title: 'TII',
            value: 'TII'
          }
        ],
        toolattraction: [
          {
            title: '出口值',
            value: 'export_value'
          },
          {
            title: '進口值',
            value: 'import_value'
          },
          {
            title: '進口市場成長趨勢',
            value: 'import_market_growth_trend'
          },
          {
            title: 'TSI',
            value: 'TSI'
          },
          {
            title: '佔全球貿易市場佔有率',
            value: 'market_share'
          },
          {
            title: '平均每人GDP',
            value: 'GDP'
          },
          {
            title: 'GNI',
            value: 'GNI'
          },
          {
            title: '農業人口比率',
            value: 'agricultural_population_proportion'
          },
          {
            title: '農業人口比率趨勢',
            value: 'agricultural_population_proportion_trend'
          },
          {
            title: '耕地面積',
            value: 'cultivated_area'
          },
          {
            title: '平均農業人口耕地面積',
            value: 'average_agricultural_population_cultivated_area'
          },
          {
            title: '市場成長相對強度',
            value: 'market_growth_intensity'
          },
          {
            title: '進口市場表現',
            value: 'market_performance'
          },
          {
            title: '市場開放程度',
            value: 'market_openness'
          },
          {
            title: '市場相對優惠關稅',
            value: 'market_preferential_tariff'
          }
        ]
      }[this.analysisType].map(options => ({
        ...options,
        options: {
          min: 0,
          max: 10,
          interval: 1
        }
      }))
    }
  },
  methods: {
    ...mapActions([
      'setModalAction'
    ]),
    async fetchData () {
      await this.fetchProducts()
      await this.fetchYears()
    },
    async fetchProducts () {
      try {
        let config = this.$ls.get('userInfo')
        let type = {
          competitiveness: '農產品',
          attraction: '農產品',
          toolcompetitiveness: '農機具',
          toolattraction: '農機具'
        }[this.analysisType]
        let response = await getProducts(config)
        let products = response.data
        this.options.products = Object.entries(products).filter(([key, value]) => value.product_type === type).map(([key, value]) => ({
          title: value.chinese_name + '(' + key + ')',
          value: key
        }))
        this.init.filters.product = null
      } catch (error) {
        throw error
      }
    },
    async fetchYears () {
      try {
        let config = this.$ls.get('userInfo')
        let response = await getYears(config)
        let years = response.data
        this.options.years = Object.values(years).map(year => ({
          title: year,
          value: year
        })).reverse()
        this.init.filters.year = null
      } catch (error) {
        throw error
      }
    },
    async fetchDatas () {
      try {
        let api = {
          competitiveness: getCompetitivenessDatas,
          attraction: getAttractionDatas,
          toolcompetitiveness: getCompetitivenessDatas,
          toolattraction: getAttractionDatas
        }[this.analysisType]
        let config = this.$ls.get('userInfo')
        let conditions = {
          competitiveness: {
            product: this.conditions.filters.product,
            year: this.conditions.filters.year,
            partner: this.conditions.filters.country
          },
          attraction: {
            product: this.conditions.filters.product,
            year: this.conditions.filters.year
          },
          toolcompetitiveness: {
            product: this.conditions.filters.product,
            year: this.conditions.filters.year,
            partner: this.conditions.filters.country
          },
          toolattraction: {
            product: this.conditions.filters.product,
            year: this.conditions.filters.year
          }
        }[this.analysisType]
        let response = await api(conditions, config)
        let datas = response.data
        this.datas = datas
        if (['070511', '070690', '070959', '080290', '080390', '081090'].includes(this.conditions.filters.product)) {
          this.dataAlert()
        }
      } catch (error) {
        this.datas = []
        if (error.response.status === 429) {
          this.addToast('error', '您的操作過於頻繁，請稍後再繼續。')
        }
      }
    },
    async fetchReportCountrys () {
      try {
        let config = this.$ls.get('userInfo')
        let conditions = {
          competitiveness: {
            product_code: this.conditions.filters.product,
            country: this.conditions.filters.country,
            module: 'market_competitiveness'
          },
          attraction: {
            product_code: this.conditions.filters.product,
            module: 'market_attractiveness'
          },
          toolcompetitiveness: {
            product_code: this.conditions.filters.product,
            country: this.conditions.filters.country,
            module: 'market_competitiveness'
          },
          toolattraction: {
            product_code: this.conditions.filters.product,
            module: 'market_attractiveness'
          }
        }[this.analysisType]
        let response = await getReportCountrys(conditions, config)
        let reportCountrys = response.data.data
        this.reportCountrys = reportCountrys
      } catch (error) {
        throw error
      }
    },
    async afterSetData (active) {
      this.init.weightings = {
        competitiveness: [
          'production_quantity',
          'yield',
          'producer_price',
          'import_price',
          'RCA',
          'TII',
          'distance'
        ],
        attraction: [
          'production_quantity',
          'export_value',
          'import_value',
          'market_size',
          'import_market_growth_trend',
          'TSI',
          'distance',
          'market_share',
          'GDP',
          'total_population',
          'market_growth_intensity',
          'market_performance',
          'market_openness',
          'market_preferential_tariff'
        ],
        toolcompetitiveness: [
          'import_price',
          'RCA',
          'TII'
        ],
        toolattraction: [
          'export_value',
          'import_value',
          'import_market_growth_trend',
          'TSI',
          'market_share',
          'GDP',
          'GNI',
          'agricultural_population_proportion',
          'agricultural_population_proportion_trend',
          'cultivated_area',
          'average_agricultural_population_cultivated_area',
          'market_growth_intensity',
          'market_performance',
          'market_openness',
          'market_preferential_tariff'
        ]
      }[this.analysisType].reduce((s, c) => ({ ...s, [c]: active ? { active: true, value: 1 } : { active: false, value: 0 } }), {})
    },
    async searchDatas (setData) {
      this.onSearch = true
      await this.fetchDatas()
      await this.fetchReportCountrys()
      if (this.datas.length && setData) {
        await this.afterSetData(true)
      }
      this.onSearch = false
    },
    dataAlert () {
      this.setModalAction({
        action: 'toast',
        customStyles: {
          padding: '0px'
        },
        param: {
          type: 'success',
          content: '<span>此產品項目為多品項，其產量、單位面積產量與生產者價格為混合資料，若需精準數值，請至其他網站查詢。</span>',
          buttons: [
            {
              title: '關閉',
              type: 'gray',
              icon: 'fa-repeat',
              result: false
            }
          ]
        },
        callback: async result => {}
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/main/analysis.vue